import { render, staticRenderFns } from "./ListLojas.vue?vue&type=template&id=7141b53a&"
import script from "./ListLojas.vue?vue&type=script&lang=js&"
export * from "./ListLojas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports